import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import "./confirmationModal.scss";
import CustomeButton from "~/components/Button";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const ConfirmationModal = ({
  visible,
  closeModal,
  confirmHandler,
  isLoading,
  title,
  subtitle,
  confirmLabel,
  variant,
  isUnpublish = false,
}) => {
  return (
    <div className="modal-main-container card flex justify-content-center align-items-center">
      <Dialog
        visible={visible}
        onHide={closeModal}
        className="confirmation-modal"
      >
        <div className="modal_icon">
          {isUnpublish ? (
            <DotLottieReact
              src="https://lottie.host/73c1d752-33ad-48e9-9257-00c689813998/GNRKFaxUVd.lottie"
              loop
              autoplay
            />
          ) : (
            <DotLottieReact
              src="https://lottie.host/f7335bf9-5792-4fa3-88b6-25fc70655b0f/vu3PzF6zgL.lottie"
              loop
              autoplay
            />
          )}
        </div>
        <div className="flex flex-column align-items-center text-center gap-1">
          <p className="title m-0">{title}</p>
          <p className="subtitle m-0">{subtitle}</p>
        </div>

        <div className="flex justify-content-center gap-2">
          <button className="cancel-btns" onClick={closeModal}>
            Cancel
          </button>
          <CustomeButton
            label={confirmLabel}
            variant={variant}
            onClick={confirmHandler}
            disabled={isLoading}
            loading={isLoading}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default ConfirmationModal;
